export default {
  title: 'JET SIGNATURE GENERATOR',
  instructions: [
    {
      step: 'Step 1',
      body: `Enter your information in the relevant fields below and watch them populate your signature to the right.`
    },
    {
      step: 'Step 2',
      body: `Check your information is correct and click the 'Copy Signature' button below the preview.`
    },
    {
      step: 'Step 3',
      body: `In your Gmail, go to Settings > Signature, paste what's on the clipboard, and save changes.`
    }
  ],
  fields: [
    {
      title: 'What’s your name?',
      placeholder: 'Enter your name',
      options: false
    },
    {
      title: 'What’s your job title?',
      placeholder: 'Enter your job title',
      options: false,
    },
    {
      title: "What’s your pronouns? (Optional)",
      placeholder: "Select your pronouns",
      options: [
        {
          value: 'n/a',
          name: 'n/a',
        },
        {
          value: 'he/him',
          name: 'he/him',
        },
        {
          value: 'she/her',
          name: 'she/her',
        },
        {
          value: 'they/them',
          name: 'they/them',
        },
      ]
    },
    {
      title: 'What’s your email address?',
      placeholder: 'Enter your email address',
      options: false
    },
    {
      title: 'What’s your mobile number?',
      placeholder: 'Enter your mobile number',
      options: false
    },
    {
      title: 'What’s your phone number?',
      placeholder: 'Enter your phone number',
      options: false
    },
    {
      title: 'What’s your website?',
      placeholder: 'Enter your website',
      options: false
    },
    {
      title: 'What office are you based in?',
      placeholder: 'Select your office location',
      options: [
        {
          name: 'Amsterdam',
          value: 'Piet Heinkade 61, \n1019 GM Amsterdam, \nThe Netherlands'
        },
        {
          name: 'Enschede (Brouwerijstraat 1)',
          value: 'Brouwerijstraat 1, \n7523 XD Enschede, \nThe Netherlands'
        },
        {
          name: 'Enschede (Brouwerijstraat 10)',
          value: 'Brouwerijstraat 10, \n7523XD, \nEnschede, \nThe Netherlands'
        },
        {
          name: 'Enschede (Rigtersbleek-Zandvoort 10)',
          value: 'Rigtersbleek-Zandvoort 10, \n7521 BE Enschede, \nThe Netherlands'
        },
        {
          name: 'London (Fleet Place House)',
          value: 'Fleet Place House, \n2 Fleet Place, \nLondon, \nEC4M 7RF'
        },
        {
          name: 'London (St Peters House)',
          value: 'St Peters House, \n130 Wood St, \nLondon \nEC2V 6DL'
        },
        {
          name: 'Borehamwood',
          value: 'Imperial Place 4, \nMaxwell Road, \nBorehamwood, \nWD6 1JN'
        },
        {
          name: 'Bristol',
          value: 'Broad Quay House, \nPrince Street, \nBristol, \nBS1 4DJ'
        },
        // {
        //   name: 'Berlin (Am Karlsbad 16)',
        //   value:
        //     'Lieferando.de - Am Karlsbad 16, 10785 Berlin, Germany \nyd.yourdelivery GmbH | Sitz der Gesellschaft: Am Karlsbad 16, 10785 Berlin, Germany \nHandelsregister: HRB 118099 B, Amtsgericht Charlottenburg | Geschäftsführer: Katharina Hauke'
        // },
        // {
        //   name: 'Berlin (Lange Straße 31, yd. yourdelivery GmbH)',
        //   value:
        //     'Lieferando.de - Am Karlsbad 16, 10785 Berlin, Germany \nyd.yourdelivery GmbH | Sitz der Gesellschaft: Am Karlsbad 16, 10785 Berlin, Germany \nHandelsregister: HRB 118099 B, Amtsgericht Charlottenburg | Geschäftsführer: Katharina Hauke'
        // },
        // {
        //   name: 'Berlin (Lange Straße 31, Takeaway Express GmbH)',
        //   value:
        //     'Lieferando.de - Koppenstraße 93 / Lange Straße 31, 10243 Berlin, Germany \nTakeaway Express GmbH | Sitz der Gesellschaft: Koppenstraße 93 / Lange Straße 31, 10243 Berlin, Germany \nHandelsregister: HRB 171445 B, Amtsgericht Charlottenburg | Geschäftsführer: Jörg Gerbig'
        // },
        {
          name: 'Berlin (CUV, yd.yourdelivery GmbH)',
          value:
            'Lieferando.de - Cuvrystr. 50, 52, 54 / Schlesische Str. 34, 10997 Berlin, Germany yd.yourdelivery GmbH | Sitz der Gesellschaft: Cuvrystr. 50, 52, 54 / Schlesische Str. 34, 10997 Berlin, Germany Handelsregister: HRB 118099 B, Amtsgericht Charlottenburg | Geschäftsführer: Lennard Neubauer'
        },
        {
          name: 'Berlin (CUV, Takeaway Express GmbH)',
          value:
            'Lieferando.de - Cuvrystr. 50, 52, 54 / Schlesische Str. 34, 10997 Berlin, Germany Takeaway Express GmbH | Sitz der Gesellschaft: Cuvrystr. 50, 52, 54 / Schlesische Str. 34, 10997 Berlin, Germany Handelsregister: HRB 171445 B, Amtsgericht Charlottenburg | Geschäftsführer: Jörg Gerbig'
        },
        {
          name: 'Brussels',
          value: 'Havenlaan 86C/B411, \n1000 Brussels, \nBelgium'
        },
        {
          name: 'Bucharest',
          value: '76 Splaiul Unirii, \nRiver Plaza, \nBuilding B 11th floor, \nDistrict 4, \nBucharest 040037, \nRomania'
        },
        {
          name: 'Copenhagen',
          value: 'Just-Eat.dk ApS, \nLyngbyvej 20, \n2100 Copenhagen'
        },
        {
          name: 'Slovakia',
          value: 'Prievozská 14, \n821 09 Bratislava'
        },
        {
          name: 'Paris',
          value: '2 ter Rue Louis Armand \n75015 PARIS'
        },
        {
          name: 'Paris (Scoober)',
          value: `31 rue du Quatre Septembre \n75002 PARIS`
        },
        {
          name: 'Milan',
          value: 'Via Gaetano de Castillia \n23. 20124 Milano \nItaly'
        },
        {
          name: 'Oslo',
          value: 'Just-Eat.no AS, \nSanakerveien 24 C \n0473 OSLO'
        },
        {
          name: 'Dublin',
          value: 'Just Eat Ireland Limited, \nSuite 1, \nNutley Building, \nMerrion Rd, \nDublin 4'
        },
        {
          name: 'Sofia',
          value: '109 Bulgaria Blvd., \nOffice 27 floor level -1, \nSofia 1404, \nBulgaria'
        },
        {
          name: 'Madrid',
          value: 'c/ Áncora 40 (entrada por calle Vara del Rey 1), \n28045 Madrid, \nSpain'
        },
        {
          name: 'Zurich',
          value: 'Werdstrasse 21 \n8004 Zürich'
        },
        {
          name: 'Wroclaw',
          value: 'Powstańców Śląskich 9, \n53-332 Wrocław, \nPoland'
        },
        {
          name: 'Vienna (TEOP Austria Branch)',
          value:
            'Lieferando.at - Kohlmarkt 8-10, 1010 Wien, Austria \nTakeaway.com European Operations B.V. Austrian Branch Firmensitz: 1011 DK Amsterdam, \nOosterdoksstraat 80, Niederlande Firmenbuchnummer: 488437, Firmenbuchgericht: Wien'
        },
        {
          name: 'Vienna (Takeaway.com Express GmbH)',
          value: 'Lieferando.at - Kohlmarkt 8-10, 1010 Wien, Austria \nTakeaway.com Express Austria GmbH | Firmensitz: Kohlmarkt 8-10, 1010 Wien \nFirmenbuchnummer: 551280g, Firmenbuchgericht: Wien'
        },
        {
          name: 'Tel Aviv',
          value: 'Derech Menahem Begin 144, \nTel Aviv 6492124, \nIsrael'
        },
        {
          name: 'Winnipeg',
          value: '410 - 242 Hargrave Street, \nWinnipeg, MB, \nR3C 0T8'
        },
        {
          name: 'Saskatoon',
          value: '220 20th St W, \nSaskatoon, SK, \nS7M 0W9'
        },
        {
          name: 'Toronto',
          value: '700-351 King St E, \nToronto, ON, \nM5A 2W4'
        },
        {
          name: 'Calgary',
          value: '300-140 4 Ave SW, \nCalgary, AB, \nT2P 3N3'
        },
        {
          name: 'Sydney',
          value: 'Level 23, \n227 Elizabeth St, \nSydney, \n2000, \nAustralia'
        },
        {
          name: 'Melbourne',
          value: ' 205 Blackburn Road, \nMount Waverley, \nVIC 3149, \nAustralia'
        },
        {
          name: 'Sao Paulo',
          value: 'Avenida Queirós Filho, \n1700 Vila Hamburguesa, \nSão Paulo, \n05319-000'
        },
        {
          name: 'Mexico City',
          value: 'Rio Lerma 4, \n6th floor, \nCuauhtemoc 06500, \nMexico City'
        }
      ]
    },
    {
      title: 'What’s your market?',
      placeholder: 'Select your market',
      options: [
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/justeat.png',
          name: 'Just Eat',
          width: 180
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/jet.png',
          name: 'Just Eat Takeaway',
          width: 300
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/menulog.png',
          name: 'Menulog',
          width: 180
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/skip-the-dishes.png',
          name: 'Skip the Dishes',
          width: 180
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/skip-duresto.png',
          name: 'Skip the Dishes (Du Resto)',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/house-icon.png',
          name: '10Bis',
          width: 100
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/house-icon.png',
          name: 'Pyszne',
          width: 100
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/house-icon.png',
          name: 'Thuisbezorgd',
          width: 100
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/house-icon.png',
          name: 'Lieferando.at',
          width: 100
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/house-icon.png',
          name: 'Lieferando.de',
          width: 100
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/bistro.png',
          name: 'Bistro.sk',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/je-business.png',
          name: 'Just Eat Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/grubhub-business.png',
          name: 'Grub Hub Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/menulog-business.png',
          name: 'Menulog Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/takeaway-business.png',
          name: 'Takeaway Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/thuisbezorgd-business.png',
          name: 'Thuisbezorgd Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/lieferando-business.png',
          name: 'Lieferando Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/skip-business.png',
          name: 'Skip Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/pyszne-business.png',
          name: 'Pyszne Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/business/10bis-business.png',
          name: '10Bis Business',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa/champions-league.png',
          name: 'UEFA Champions League',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa/europa-league.png',
          name: 'UEFA Europa League & Conference League',
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa/womans-euros.png',
          name: `UEFA Women's EURO`,
          width: 200
        },
        {
          value: 'https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/uefa/uefa-womans.png',
          name: `UEFA Women's Football`,
          width: 200
        }
      ]
    }
  ]
};
